<script setup>
  import { useI18n } from 'vue-i18n';
  import RadioControl from '@/components/RadioControl.vue';

  const { t } = useI18n();

  const model = defineModel();

  // Values are i18n keys; translated at the render site.
  const options = {
    30: 'windAlerts.every30Mins',
    60: 'windAlerts.every60Mins',
    120: 'windAlerts.every2Hours',
    360: 'windAlerts.every6Hours',
    720: 'windAlerts.every12Hours',
    1440: 'windAlerts.onceADay'
  };
</script>

<template>
  <div class="jwx-modal__section">
    <div class="jwx-modal__section-body">
      <ul class="jwx-block jwx-table-view" data-surface="1">
        <li v-for="(label, value) in options" :key="value" class="jwx-table-view__row">
          <div class="jwx-table-view__row-content">
            <label :for="'frequency-' + value" class="jwx-table-view__row-label">{{ t(label) }}</label>
            <div class="jwx-table-view__row-actions">
              <RadioControl
                v-model="model"
                name="frequency"
                :id="'frequency-' + value"
                :value="Number(value)"
                :srLabel="t('windAlerts.srSelect', { label: t(label) })"
              />
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
